import React, { useEffect } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import CustomToast from "./components/common/CustomToast";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./config/AppRoutes";
import { useAppDispatch, useAppSelector } from "./redux/store";
import { getCompany } from "./redux/actions/companyActions";
import { loadLocalSettings } from "./redux/actions/settingsActions";

const App = () => {
  const [theme, colorMode] = useMode();
  const dispatch = useAppDispatch();

  const { userInfo } = useAppSelector((state) => state.auth);
  const { company } = useAppSelector((state) => state.company);

  useEffect(() => {
    if (userInfo && !company) {
      dispatch(getCompany());
    }
    dispatch(loadLocalSettings());
  }, [company, dispatch, userInfo]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <CustomToast />
        <Router>
          <AppRoutes />
        </Router>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default App;
